import React, { useMemo } from "react";
import * as Tooltip from "@radix-ui/react-tooltip";

interface TruncatedTextProps {
  limit: number;
  className?: string;
  children: string;
}

const TruncatedText: React.FC<TruncatedTextProps> = ({
  limit,
  className,
  children,
}) => {
  const displayText = useMemo(() => {
    if (children.length < limit) return children;
    return `${children.slice(0, limit)}...`;
  }, [limit, children]);

  if (children.length < limit) {
    return <span className={className}>{displayText}</span>;
  }

  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <span className={className}>{displayText}</span>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            className="
				z-50
				max-w-xs
				rounded-md
				bg-gray-900
				px-3
				py-2
				text-sm
				text-white
				shadow-lg
				leading-snug
				break-words
				animate-in
				fade-in
				zoom-in-95
  			"
            sideOffset={5}
          >
            {children}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default TruncatedText;
